import { render, staticRenderFns } from "./DeactivateUser.vue?vue&type=template&id=3eb8b913&lang=pug"
import script from "./DeactivateUser.vue?vue&type=script&lang=js"
export * from "./DeactivateUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports